var map = {
	"./add-error.svg": 11805,
	"./android.svg": 40776,
	"./apple.svg": 75574,
	"./arrow.svg": 55270,
	"./close-thin.svg": 17032,
	"./close.svg": 67165,
	"./demo-picture.svg": 86858,
	"./drag-icon.svg": 48477,
	"./error.svg": 78868,
	"./fair.svg": 57190,
	"./feedback.svg": 98741,
	"./highlight.svg": 15547,
	"./hint.svg": 51480,
	"./orange-sticker.svg": 84480,
	"./paid.svg": 7433,
	"./premium.svg": 34857,
	"./rotate.svg": 92847,
	"./success.svg": 12015,
	"./top3-transparent.svg": 63301,
	"./top3.svg": 9836,
	"./valid.svg": 25296,
	"./warning-black.svg": 77788,
	"./warning.svg": 24041,
	"./wp.svg": 96484,
	"./zoom.svg": 46146
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29513;